import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.aviabookingReference
)

export const selectCountries = createSelector(
    baseSelector,
    (state) => state.countries
)

export const selectCountriesMap = createSelector(
    baseSelector,
    (state) => state.countriesMap
)

export const selectCountriesError = createSelector(
    baseSelector,
    (state) => state.countriesError
)

export const selectCountriesLoading = createSelector(
    baseSelector,
    (state) => state.isCountriesLoading
)

export const selectCountriesFirstLoad = createSelector(
    baseSelector,
    (state) => state.isCountriesFirstLoad
)

export const selectAirlines = createSelector(
    baseSelector,
    (state) => state.airlines
)

export const selectAirlinesMap = createSelector(
    baseSelector,
    (state) => state.airlinesMap
)

export const selectAirlinesError = createSelector(
    baseSelector,
    (state) => state.airlinesError
)

export const selectAirlinesLoading = createSelector(
    baseSelector,
    (state) => state.isAirlinesLoading
)

export const selectAirlinesFirstLoad = createSelector(
    baseSelector,
    (state) => state.isAirlinesFirstLoad
)

export const selectAirports = createSelector(
    baseSelector,
    (state) => state.airports
)

export const selectAirportsMap = createSelector(
    baseSelector,
    (state) => state.airportsMap
)

export const selectAirportsError = createSelector(
    baseSelector,
    (state) => state.airportsError
)

export const selectAirportsLoading = createSelector(
    baseSelector,
    (state) => state.isAirportsLoading
)

export const selectAirportsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isAirportsFirstLoad
)

export const selectAircraft = createSelector(
    baseSelector,
    (state) => state.aircraft
)

export const selectAircraftMap = createSelector(
    baseSelector,
    (state) => state.aircraftMap
)

export const selectAircraftError = createSelector(
    baseSelector,
    (state) => state.aircraftError
)

export const selectAircraftLoading = createSelector(
    baseSelector,
    (state) => state.isAircraftLoading
)

export const selectAircraftFirstLoad = createSelector(
    baseSelector,
    (state) => state.isAircraftFirstLoad
)